/* DemoPool · home interactions: liquid hover layer, segment tiles → builder, pack builder summary, sample form */
(() => {
  // liquid layer (Figma "liquid": 3 blobs)
  document.querySelectorAll('[data-liquid]').forEach(el => {
    const l = document.createElement('span'); l.className = 'dp-liquid'; l.setAttribute('aria-hidden', 'true'); l.innerHTML = '<i></i><i></i><i></i>';
    el.prepend(l);
  });
  const f = document.getElementById('builder');
  if (f) {
    const seg = f.querySelector('#b-seg'), count = f.querySelector('#b-count'), sum = f.querySelector('#b-sum'), price = f.querySelector('#b-price'), atc = f.querySelector('#b-atc');
    const chips = [...f.querySelectorAll('.dp-chip')];
    const fmt = n => Number(n).toLocaleString('en-US');
    const update = () => {
      const o = seg.selectedOptions[0], n = +o.dataset.n;
      count.textContent = fmt(n) + ' verified';
      f.querySelectorAll('input[name=amount]').forEach(i => { i.disabled = +i.value > n; });
      if (f.querySelector('input[name=amount]:checked:disabled')) f.querySelector('input[name=amount]:not(:disabled)').checked = true;
      const g = chips.filter(c => c.getAttribute('aria-pressed') === 'true').map(c => c.dataset.genre);
      const r = f.querySelector('input[name=region]:checked').value;
      sum.textContent = `${o.textContent} · ${g.includes('Any') ? 'Any genre' : g.join(', ')} · ${r}`;
      price.textContent = '$' + f.querySelector('input[name=amount]:checked').dataset.price;
    };
    chips.forEach(c => c.addEventListener('click', () => {
      const any = c.dataset.genre === 'Any', on = c.getAttribute('aria-pressed') !== 'true';
      if (any) chips.forEach(x => x.setAttribute('aria-pressed', x === c));
      else {
        c.setAttribute('aria-pressed', on);
        chips[0].setAttribute('aria-pressed', !chips.slice(1).some(x => x.getAttribute('aria-pressed') === 'true'));
      }
      update();
    }));
    f.addEventListener('change', update);
    f.addEventListener('submit', e => { e.preventDefault(); atc.firstChild.textContent = 'Added '; setTimeout(() => { atc.firstChild.textContent = 'Add to cart '; }, 1500); });
    document.querySelectorAll('[data-seg]').forEach(t => t.addEventListener('click', () => { seg.value = t.dataset.seg; update(); }));
    update();
  }
})();
